import { Component } from '@angular/core';
import {NavController, NavParams, AlertController} from 'ionic-angular';
import {UserService} from "../../app/services/user.service";

/*
  Generated class for the Phonenumber page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-phonenumber',
  templateUrl: 'phonenumber.html',
  providers: [UserService]
})
export class PhonenumberPage {
  public phonenumber : string;

  constructor(public alertCtrl : AlertController, public userService : UserService, public navCtrl: NavController, public navParams: NavParams) {
    this.userService.getAccount().then((account) => {
      this.phonenumber = account.phonenumber;
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PhonenumberPage');
  }

  removePhonenumber(){

  }

}



// WEBPACK FOOTER //
// ./src/pages/phonenumber/phonenumber.ts